module.exports = __webpack_public_path__ + "img/product_img2.151ad44f.png";